<ng-container [ngSwitch]="column.filterType">
  <app-grid-percentage-filter-menu
    *ngSwitchCase="'percentage'"
    [column]="gridColumn"
    [filter]="filter"
    [filterService]="filterService"
  ></app-grid-percentage-filter-menu>
  <kendo-grid-numeric-filter-menu
    *ngSwitchCase="'numeric'"
    [column]="gridColumn"
    [filter]="filter"
    [filterService]="filterService"
  ></kendo-grid-numeric-filter-menu>
  <kendo-grid-string-filter-menu
    *ngSwitchCase="'text'"
    [column]="gridColumn"
    [filter]="filter"
    [filterService]="filterService"
  ></kendo-grid-string-filter-menu>
  <kendo-grid-date-filter-menu
    *ngSwitchCase="'date'"
    [column]="gridColumn"
    [filter]="filter"
    [filterService]="filterService"
  ></kendo-grid-date-filter-menu>
  <kendo-dropdownlist
    *ngSwitchCase="'boolean'"
    textField="name"
    valueField="value"
    [data]="
      column.filterOptions || [
        { name: 'Yes', value: true },
        { name: 'No', value: false },
      ]
    "
    [value]="booleanValue"
    (selectionChange)="onCustomFilterChange($event)"
  ></kendo-dropdownlist>
  <kendo-multiselect
    *ngSwitchCase="'multiselect'"
    textField="name"
    valueField="value"
    [data]="column.filterOptions || []"
    [value]="multiselectValue"
    [placeholder]="'Select...'"
    (valueChange)="onMultiselectFilterChange($event)"
  ></kendo-multiselect>
  <ng-container *ngSwitchCase="'custom'">
    <ng-container *ngIf="column.filterTemplate">
      <ng-container
        *ngTemplateOutlet="
          column.filterTemplate;
          context: { column: column, filterService: filterService }
        "
      ></ng-container>
    </ng-container>
  </ng-container>
</ng-container>
